import classNames from "classnames/bind";
import PropTypes from "prop-types";
import * as React from "react";
import useEmblaCarousel from "embla-carousel-react";
import SectionTitle from "../../Layout/Section/Title";
import * as sliderStyles from "./slider.module.css";
import SectionDescription from "../../Layout/Section/Description";
import TemplateString from "../TemplateString";

const cx = classNames.bind(sliderStyles);

export const SliderApiContext = React.createContext(null);

const Slider = ({
    children,
    sliderClassName,
    containerClassName,
    titleClassName,
    options,
    title,
    navigation,
    pagination,
    alignLeft,
    desc,
}) => {
    const defaultOptions = {
        align: "start",
        containScroll: "trimSnaps",
    };

    const [emblaRef, emblaApi] = useEmblaCarousel({...defaultOptions, ...options});

    return (
        <SliderApiContext.Provider value={emblaApi}>
            <div>
                {(title || navigation) && (
                    <div className={cx({slider__header: true, slider__header_left: alignLeft}, titleClassName)}>
                        <SectionTitle>
                            <TemplateString template={title} />
                        </SectionTitle>
                        {desc && (
                            <SectionDescription>
                                <TemplateString template={desc} />
                            </SectionDescription>
                        )}
                        {navigation}
                    </div>
                )}
                <div ref={emblaRef} className={cx(sliderClassName)}>
                    <div className={cx(containerClassName, "embla__container")}>{children}</div>
                </div>
            </div>
            {pagination && <div className={sliderStyles.slider__footer}>{pagination}</div>}
        </SliderApiContext.Provider>
    );
};

Slider.defaultProps = {
    children: [],
    sliderClassName: sliderStyles.slider__wrapper,
    containerClassName: sliderStyles.slider__container,
    titleClassName: "",
    options: {},
    title: "",
    desc: "",
    navigation: null,
    pagination: null,
    alignLeft: false,
};

Slider.propTypes = {
    children: PropTypes.node,
    sliderClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    containerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    titleClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    options: PropTypes.objectOf(PropTypes.object),
    title: PropTypes.node,
    desc: PropTypes.node,
    navigation: PropTypes.node,
    pagination: PropTypes.node,
    alignLeft: PropTypes.bool,
};

export default Slider;
